import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { ViewPermissions, ViewPermissionKey } from '../../../vista/shared/data/permissions';
import * as models from '../../models';
import * as selectors from '../../selectors';

@Injectable()
export class StoreViewPermissionsService extends ViewPermissions {
  constructor(private store$: Store<any>) {
    super();
  }

  granted(key: ViewPermissionKey): Observable<boolean> {
    return this.store$.pipe(
      select(selectors.getUserUserViewPermissions),
      map((viewPermissions: models.IPermissions) => isGranted(viewPermissions, key)),
      distinctUntilChanged()
    );
  }
}

// A nested object is a grant, as the route guard reads it: the user mapper turns `x: true` into
// `x: { modify: true }` when the user also holds `x.modify`.
function isGranted(viewPermissions: models.IPermissions, key: ViewPermissionKey): boolean {
  let node: models.IPermissions | boolean = viewPermissions;
  for (const segment of key.split('.')) {
    if (typeof node !== 'object' || node === null) {
      return false;
    }
    node = node[segment];
  }
  return node === true || (typeof node === 'object' && node !== null);
}
